module.exports = __webpack_public_path__ + "static/media/RadioButtonOn.efaea3bc.svg";